// extracted by mini-css-extract-plugin
export default {"supportpage":"styles_supportpage__nwxVB","title":"styles_title__l1Az7","photoholder":"styles_photoholder__uxACy","photo":"styles_photo__BBhWg"};